export const API_views_workspace = (workspaceId: string): string =>
  `api/v1/views${workspaceId ? `?workspaceId=${workspaceId}` : ''}`;
export const API_views_view = (workspaceId: string, viewId: string): string =>
  `api/v1/views/${viewId}${workspaceId ? `?workspaceId=${workspaceId}` : ''}`;
export const API_views_default = (): string => 'api/v1/views/default';
export const API_views_reorder = (): string => 'api/v1/views/reorder';
export const API_views_delete = (workspaceId: string, viewId: string): string =>
  `/api/v1/views/${viewId}${workspaceId ? `?workspaceId=${workspaceId}` : ''}`;
